import LabServiceModel from "@/models/LabServiceModel";
import AnalyteModel from "@/models/lab/AnalyteModel";
import InstrumentCollection from "@/collections/lab/InstrumentCollection";
import MeasureUnitCollection from "@/collections/lab/MeasureUnitCollection";

export default class AnalysisModel extends LabServiceModel {
  modelName() {
    return "analysis";
  }
  icon() {
    return 'link';
  }
  defaults() {
    return {
      id: null,
      analyte_id: null,
      analyte: null,
      name: null,
      modus_name: null,
      extraction_name: null,
      measurement_method: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      sample_type: null,
      instruments: {},
      units: {}
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      analyte_id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      modus_name: val => this.nullStringMutator(val),
      extraction_name: val => this.nullStringMutator(val),
      measurement_method: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getAnalyte() {
    return this.getRelatedModel(AnalyteModel, "analyte");
  }
  getInstruments() {
    return this.getRelatedCollection(new InstrumentCollection(), "instruments");
  }
  getUnits() {
    return this.getRelatedCollection(new MeasureUnitCollection(), "units");
  }
}
